import { api } from './client';
import type { Bet, PredictionTally } from './types';

export const betsApi = {
  placeOrUpdate: (
    matchId: string,
    homeScore: number,
    awayScore: number,
    penaltyHomeScore?: number | null,
    penaltyAwayScore?: number | null,
  ) =>
    api.post<Bet>('/bets', {
      matchId,
      homeScore,
      awayScore,
      penaltyHomeScore: penaltyHomeScore ?? null,
      penaltyAwayScore: penaltyAwayScore ?? null,
    }),
  mine: () => api.get<Bet[]>('/bets/me'),
  // Anonymous summary of how others predicted this match. Backend returns an
  // empty list while betting is still open (only LIVE/FINISHED matches expose it).
  summary: (matchId: string) => api.get<PredictionTally[]>(`/bets/match/${matchId}/summary`),
  forMatch: async (matchId: string): Promise<Bet | null> => {
    try {
      // Backend answers 204 (→ undefined) when the user has no bet; React Query
      // rejects undefined query data, so normalise it to null.
      return (await api.get<Bet>(`/bets/match/${matchId}`)) ?? null;
    } catch {
      return null;
    }
  },
};
